import DdFooterButton from '@/components/DdFooterButton'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
// import dolly from '@/rahmen/utils/dolly'
// import modals from '@/ddv2.library/modals'

import message from '@/ddv2.library/messages'
// import tax from '@/ddv2.library/tax'
import header from '@/ddv2.library/header'
// import modals from '@/ddv2.library/modals'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSimpleTable = () => import('@/components/DdSimpleTable')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'TeikeiCourseEdit',
  mixins: [flowMixin],
  components: {
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdCheckbox,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdEditDialog,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSimpleTable,
    DdSubHeader,
    DdSwitch,
    DdTextArea,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdTimeBox
  },
  data: () => ({
    invalidMessages: {},
    id: 0,
    hinmokuCount: 0,
    modeOfEdit: 2,
    modeKengen: 2,
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {
      mstTokuisakiInfo: {},
      mstHacchusakiInfo: {}
    },
    // オートコンプリート定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // ダイアログ定義
    // ----------------------------------------------------------------------------------------------------
    shohinEditDialog: false,
    shohinEditIndex: -1,
    shohinMaxIndex: -1,
    // 表示制御
    selectNinushiCd: '',
    hatsuchiSwitch: false,
    chakuchiSwitch: false,
    hacchusakiDispFlg: false,
    expandKeiyuchi: false
  }),
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      taxList: 'DDMasters/msysTax'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    /*
    // 売上種別フィルター
    filteredUriageBunruiKubunList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN033')
    },
    */
    // 貨物区分フィルター
    filteredKamotsuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT025')
    },
    // 契約種別フィルター
    filteredKeiyakuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBTC04')
    },
    // 運行種別フィルター
    filteredUnkoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBTC02')
    },
    // 運行間隔フィルター
    filteredUnkoKankakuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBTC03')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 支払運賃算出
    shiharaiGokeiAmount () {
      let amount = 0

      let shiharaiKihonUnchin = this.rec.shiharaiKihonUnchin ?? '0'
      let shiharaiTsukoryo = this.rec.shiharaiTsukoryo ?? '0'
      let shiharaiKingaku1 = this.rec.seikyuKingaku1 ?? '0'
      let shiharaiKingaku2 = this.rec.shiharaiKingaku2 ?? '0'
      if (this.rec.shiharaiKihonUnchin === undefined || this.rec.shiharaiKihonUnchin === '') { shiharaiKihonUnchin = '0' }
      if (this.rec.shiharaiTsukoryo === undefined || this.rec.shiharaiTsukoryo === '') { shiharaiTsukoryo = '0' }
      if (this.rec.shiharaiKingaku1 === undefined || this.rec.shiharaiKingaku1 === '') { shiharaiKingaku1 = '0' }
      if (this.rec.shiharaiKingaku2 === undefined || this.rec.shiharaiKingaku2 === '') { shiharaiKingaku2 = '0' }

      const shiharaiKazeiAmount = parseInt(shiharaiKihonUnchin, 10) + parseInt(shiharaiKingaku1, 10) + parseInt(shiharaiKingaku2, 10)
      /*
      const hasuKeisanKbn = this.rec.mstHacchusakiInfo ? this.rec.mstHacchusakiInfo.unchinHasuKeisanKbn : '02'

      if (shiharaiKazeiAmount > 0) {
        shiharaiKazeiAmount = tax.calcTaxToIncluded(shiharaiKazeiAmount, hasuKeisanKbn, new Date())
      }
      */
      amount = shiharaiKazeiAmount + parseInt(shiharaiTsukoryo, 10)

      return amount
    },
    // 請求合計金額算出
    seikyuGokeiAmount () {
      let amount = 0

      let seikyuKihonUnchin = this.rec.seikyuKihonUnchin ?? '0'
      let seikyuTsukoryo = this.rec.seikyuTsukoryo ?? '0'
      let seikyuKingaku1 = this.rec.seikyuKingaku1 ?? '0'
      let seikyuKingaku2 = this.rec.seikyuKingaku2 ?? '0'
      if (this.rec.seikyuKihonUnchin === undefined || this.rec.seikyuKihonUnchin === '') { seikyuKihonUnchin = '0' }
      if (this.rec.seikyuTsukoryo === undefined || this.rec.seikyuTsukoryo === '') { seikyuTsukoryo = '0' }
      if (this.rec.seikyuKingaku1 === undefined || this.rec.seikyuKingaku1 === '') { seikyuKingaku1 = '0' }
      if (this.rec.seikyuKingaku2 === undefined || this.rec.seikyuKingaku2 === '') { seikyuKingaku2 = '0' }

      const seikyuKazeiAmount = parseInt(seikyuKihonUnchin, 10) + parseInt(seikyuKingaku1, 10) + parseInt(seikyuKingaku2, 10)
      /*
      const hasuKeisanKbn = this.rec.mstTokuisakiInfo ? this.rec.mstTokuisakiInfo.unchinHasuKeisanKbn : '02'

      if (seikyuKazeiAmount > 0) {
        seikyuKazeiAmount = tax.calcTaxToIncluded(seikyuKazeiAmount, hasuKeisanKbn, new Date())
      }
      */
      amount = seikyuKazeiAmount + parseInt(seikyuTsukoryo, 10)

      return amount
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isUpdateMode () {
      return this.modeOfEdit === 1 || this.modeOfEdit === 2
    },
    isCancelButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        hatsuchiSwitch: this.hatsuchiSwitch,
        chakuchiSwitch: this.chakuchiSwitch
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const option = {
        nextCallback: next
      }
      this.preventTransition(option)
    },
    fetchData: function () {
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.rec.id)
        this.HttpClient
          .get(`/api/v1/VwCD2mstd0370/GetByCourseId?id=${this.id}`)
          .then((data) => {
            if (data.isValid === false) { return this.setInvalidSummaryMessage(data.summaryMessage.messageCd) }

            if (data.payload) {
              this.rec = data.payload

              if (!this.rec.ninushiId) { this.selectNinushiCd = this.getTorihikisakiCdFromId(this.rec.ninushiId) }

              this.hacchusakiDispFlg = this.rec.hacchusakiFlg

              if (this.rec.hatsuchiHms) { this.rec.hatsuchiHms = (this.rec.hatsuchiHms).slice(0, 5) }

              if (this.rec.chakuchiHms) { this.rec.chakuchiHms = (this.rec.chakuchiHms).slice(0, 5) }

              this.dispSwitchControl()
              this.clearInvalidMessage(this.$refs)
            }
            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'msthacchakuchi', 'mstshubetsu', 'msyskubun', 'msystax'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            self.rec.seikyuShashuSbtCd = c.seikyuShashuSbtCd
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('existsIdMethod')
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // 得意先設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 荷主IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeNinushi: function () {
      if (!this.rec.ninushiId) {
        this.rec.mstTokuisakiInfo = {}
        this.selectNinushiCd = ''
        return
      }
      this.getTokuisakiInfo(this.rec.ninushiId)
    },
    getTokuisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2mstd0370/MstTokuisakiInfoFind?id=${this.rec.ninushiId}`)
          .then((data) => {
            this.rec.mstTokuisakiInfo = data.payload
            this.selectNinushiCd = this.getTorihikisakiCdFromId(this.rec.ninushiId)
            console.log('getKingakuKomoku', this.rec.mstTokuisakiInfo)
          })
        resolve()
      })
    },
    hacchakuchiFilter (elem) {
      const self = this
      const target = filter.dateFormatter(new Date())
      return (elem.tekiyoStartYmdDisp <= target) &&
            (elem.tekiyoEndYmdDisp >= target) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },
    // ----------------------------------------------------------------------------------------------------
    // 発注先設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 発注先IDが入力されたら、設定情報取得メソッドを呼ぶ
    changeHacchusaki: function () {
      if (!this.rec.hacchusakiId) {
        this.rec.mstHacchusakiInfo = {}
        return
      }
      this.getHacchusakiInfo(this.rec.hacchusakiId)
    },
    getHacchusakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2mstd0370/MstHacchusakiInfoFind?id=${this.rec.hacchusakiId}`)
          .then((data) => {
            this.rec.mstTokuisakiInfo = data.payload
            console.log('getKingakuKomoku', this.rec.mstHacchusakiInfo)
          })
        resolve()
      })
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.dispSwitchControl()
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.HttpClient.post('/api/v1/VwCD2mstd0370/Delete', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {
            seikyuShashuSbtCd: self.rec.seikyuShashuSbtCd
          }
        }
        /* settingReloadWindow: function () {
          return true
        } */
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.rec.teikeiCourseNo = ''
          self.rec.mstTeikeiKihonJuchuId = 0
          self.rec.mstTeikeiKihonHacchuId = 0
          self.rec.mstTeikeiCourceHacchuId = 0
          self.modeOfEdit = 0
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      this.rec.hacchusakiFlg = this.hacchusakiDispFlg

      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
            seikyuShashuSbtCd: self.rec.seikyuShashuSbtCd
          }
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      var f = this.HttpClient.post('/api/v1/VwCD2mstd0370/Create', this.rec)
      return f
    },
    registerValidate: function () {
      if (!this.rec.tantoEigyoshoId) {
        this.$refs.tantoEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.rec.ninushiId) {
        this.$refs.ninushiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.rec.seikyuShashuSbt) {
        this.$refs.seikyuShashuSbt[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.rec.kamotsuKbn) {
        this.$refs.kamotsuKbn[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (this.rec.hatsuchiHms && this.rec.chakuchiHms) {
        if (this.rec.hatsuchiHms === this.rec.chakuchiHms) {
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['発時刻', '着時刻']))
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['発時刻', '着時刻']))
          return false
        }
      }
      return true
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rec = {}
      this.selectNinushiCd = ''
      this.rec.mstTokuisakiInfo = {}
      this.rec.mstHacchusakiInfo = {}
      this.copyMode = 0
      this.dispSwitchControl()
      this.hacchusakiDispFlg = false
      this.rec.startLockFlg = true
      this.rec.endLockFlg = false
      this.rec.id = 0
      this.$set(this.rec, 'ninushiId', '')
      this.$set(this.rec, 'tantoEigyoshoId', '')
      this.$set(this.rec, 'hacchusakiId', '')
      this.$set(this.rec, 'hatsuchiId', '')
      this.$set(this.rec, 'keiyuchiId1', '')
      this.$set(this.rec, 'keiyuchiId2', '')
      this.$set(this.rec, 'keiyuchiId3', '')
      this.$set(this.rec, 'keiyuchiId4', '')
      this.$set(this.rec, 'keiyuchiId5', '')
      this.$set(this.rec, 'chakuchiId', '')
      this.rec.teikeiKihonNo = null
    },
    dispSwitchControl: function () {
      this.hatsuchiSwitch = Boolean(!this.rec.hatsuchiId && this.rec.hatsuchiBiko)
      this.chakuchiSwitch = Boolean(!this.rec.chakuchiId && this.rec.chakuchiBiko)
      this.expandKeiyuchi = Boolean(this.rec.keiyuchiId2 || this.rec.keiyuchiId2Biko || this.rec.keiyuchiId3 || this.rec.keiyuchiId3Biko || this.rec.keiyuchiId4 || this.rec.keiyuchiId4Biko || this.rec.keiyuchiId5 || this.rec.keiyuchiId5Biko)
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = !this.hatsuchiSwitch
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = !this.chakuchiSwitch
    },
    getTorihikisakiCdFromId: function (pTorihikisakiId) {
      const target = filter.dateFormatter(new Date())
      var torihikisaki = this.torihikisakiList.filter((t) => {
        return t.id === pTorihikisakiId && t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
      if (torihikisaki.length > 0) {
        return torihikisaki[0].torihikisakiCd
      }
      return ''
    },
    // --------------------------------------------------------------------------------
    // 経由地展開
    // --------------------------------------------------------------------------------
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    }
  }
}
